import { IconPlus } from '@tabler/icons-react';
import NSIcon from 'bricks/NSIcon/NSIcon';
import classNames from 'classnames';
import { NSButton } from 'bricks';
import { getReportTypeFromLabel, getReportTypeClassName } from 'views/ReportBuilder/helpers';
import { ReportTypes } from 'views/ReportBuilder/constants';

export interface INewReportButtonProps {
    reportName: string;
    handleReportSelection: (reportType: ReportTypes) => void;
}

const NewReportButton = ({ reportName, handleReportSelection }: INewReportButtonProps) => (
    <NSButton
        callback={() => handleReportSelection(getReportTypeFromLabel(reportName))}
        className={classNames('mt-2 py-2 w-100', getReportTypeClassName(reportName))}
        color="secondary"
        outline={false}
    >
        <div className="text-white d-flex justify-content-between align-items-center">
            <h5 className="ml-2 my-0">{reportName}</h5>
            <NSIcon icon={IconPlus} size="lg" />
        </div>
    </NSButton>
);

export default NewReportButton;
